<template>
    <template v-if="isMobile == false">
        <div id="search_box" class="pconly" :class="{ underlayer: isUnderLayer }">
            <form name="InputForm" id="InputForm">
                <div class="section">
                    <h3 id="departureplace_ttl">出発地</h3>
                    <div id="departureplace_box">
                        <search-departure-area-component :master=master :condition=searchCondition v-on:departureArea="searchCondition.selectedDepartureArea.value = $event"></search-departure-area-component>
                        <search-departure-pref-component :master=master :condition=searchCondition v-on:departurePref="searchCondition.selectedDeparturePref.value = $event"></search-departure-pref-component>
                        <search-departure-component :master=master :condition=searchCondition v-on:departure="searchCondition.selectedDeparture.value = $event"></search-departure-component>
                    </div>
                </div>
                <div class="section">
                    <h3 id="skiplace_ttl">スキー場</h3>
                    <div id="skiplace_box">
                        <search-destination-area-component :master=master :condition=searchCondition v-on:destinationArea="searchCondition.selectedDestinationArea.value = $event"></search-destination-area-component>
                        <search-destination-pref-component :master=master :condition=searchCondition v-on:destinationPref="searchCondition.selectedDestinationPref.value = $event"></search-destination-pref-component>
                        <search-destination-component :master=master :condition=searchCondition v-on:destination="searchCondition.selectedDestination.value = $event"></search-destination-component>
                    </div>
                </div>
                <div class="section">
                    <h3 id="departure_ttl">出発日</h3>
                    <div id="departure_box">
                        <search-date-component :condition=searchCondition v-on:targetDate="searchCondition.selectedDate.value = $event"></search-date-component>
                    </div>
                </div>
                <div class="section">
                    <div class="transportation_ttl_wrap">
                        <h3 id="transportation_ttl">交通手段</h3>
                        <div class="all_wrap">
                            <search-transportation-check-component :condition=searchCondition  v-on:transportAllChecked="searchCondition.transportationAllCheck.value = $event"></search-transportation-check-component>
                        </div>
                    </div>
                    <div id="transportation_box">
                        <div id="trafficCategory">
                            <search-transportation-component :master=master :condition=searchCondition v-on:transportation="searchCondition.selectedTransportation.value = $event"></search-transportation-component>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <h3 id="conditon_ttl">絞り込み条件</h3>
                    <div id="conditon_select">
                        <search-option-component :master=master :condition=searchCondition v-on:option="searchCondition.selectedOption.value = $event"></search-option-component>
                    </div>
                </div>
                <div id="s_btn">
                    <search-button-component :condition=searchCondition></search-button-component>
                </div>
            </form>
        </div>
    </template>
    <template v-else>
        <div id="search_box_sp" class="sponly">
            <h2 class="ttl">日帰りスキーツアーを検索</h2>
            <form name="InputForm_sp" id="InputForm_sp">
                <div class="departures form_box">
                    <search-departure-sp-component :master=master :condition=searchCondition></search-departure-sp-component>
                </div>
                <div class="skiselecter form_box">
                    <search-destination-sp-component :master=master :condition=searchCondition></search-destination-sp-component>
                </div>
                <div class="departure_date form_box">
                    <ul>
                        <li class="ttl">出発日</li>
                        <li class="item">
                            <search-date-component :condition=searchCondition v-on:targetDate="searchCondition.selectedDate.value = $event"></search-date-component>
                        </li>
                    </ul>
                </div>
                <div class="traffic select_form_box">
                    <div class="ttl">交通手段</div>
                    <div id="trafficCategory_sp" class="check_select">
                        <search-transportation-component :master=master :condition=searchCondition v-on:transportation="searchCondition.selectedTransportation.value = $event"></search-transportation-component>
                    </div>
                    <div class="all_select">
                        <search-transportation-check-component :condition=searchCondition  v-on:transportAllChecked="searchCondition.transportationAllCheck.value = $event"></search-transportation-check-component>
                    </div>
                </div>
                <div class="refine select_form_box">
                    <div class="ttl">絞り込み条件</div>
                    <div class="check_select">
                        <search-option-component :master=master :condition=searchCondition v-on:option="searchCondition.selectedOption.value = $event"></search-option-component>
                    </div>
                </div>
                <div id="submit_btn">
                    <search-button-component :condition=searchCondition></search-button-component>
                </div>
            </form>
        </div>
    </template>
</template>

<script>
    import { reactive, watchEffect } from 'vue'
    export default ({
        props: {
            departure_area : {type: String, require: true},
            departure_pref : {type: String, require: true},
            departure : {type: String, require: true},
            destination_area : {type: String, require: true},
            destination_pref : {type: String, require: true},
            destination : {type: String, require: true},
            transportation : {type: String, require: true},
            option: {type: String, require: true},
            is_under_layer: {type: Boolean, require:true},
            condition: {type: String},
            current_date: {type: String},
            is_mobile: {type: Boolean, require:true},
        },
        setup (props) {
            const master = {
                departureAreaItemList: props.departure_area,
                departurePrefItemList: props.departure_pref,
                departureItemList: props.departure,
                destinationAreaItemList: props.destination_area,
                destinationPrefItemList: props.destination_pref,
                destinationItemList: props.destination,
                transportationItemList: props.transportation,
                optionItemList: props.option,
            }

            // 検索条件。ここに戻しをすると条件が戻る。
            const searchCondition = reactive({
                selectedDepartureArea: {
                    value:"", // 出発地都道府県の選択
                    searchKey: "deptArea",
                    master: JSON.parse(props.departure_area),
                },
                selectedDeparturePref: {
                    value:"", // 出発地都道府県の選択
                    searchKey: "deptPref",
                    master: JSON.parse(props.departure_pref),
                },
                selectedDeparture: {
                    value: [],
                    searchKey: "dept",
                    master: JSON.parse(props.departure),
                },
                selectedDestinationArea: {
                    value:"", // 到着地都道府県の選択
                    searchKey: "destArea",
                    master: JSON.parse(props.destination_area),
                },
                selectedDestinationPref: {
                    value:"", // 到着地都道府県の選択
                    searchKey: "destPref",
                    master: JSON.parse(props.destination_pref),
                },
                selectedDestination: {
                    value: "",
                    searchKey: "dest",
                    master: JSON.parse(props.destination),
                },
                transportationAllCheck: {
                    value: false, // 移動手段全チェック
                    searchKey: ""
                },
                selectedTransportation:{
                    value: [],
                    searchKey: "tran",
                    master: JSON.parse(props.transportation),
                },
                selectedOption:{
                    value: [],
                    searchKey: "option",
                    master: JSON.parse(props.option),
                },
                selectedDate: {
                    value: new Date(),
                    searchKey: "date",
                    isMonth: true,
                },
            })

            // 今指定されている日付の情報を設定する。
            let currentDate = JSON.parse(props.current_date)
            if (currentDate && currentDate['searchDate']) {
                searchCondition['selectedDate']['isMonth'] = currentDate['searchDate']['isMonth']
            }

            // 検索の値が設定されている場合は、戻す
            if (props.condition) {
                let json = JSON.parse(props.condition)
                if(Object.keys(json).length) {
                    Object.keys(json).forEach(function (key) {
                        searchCondition[key]['value'] = json[key]
                    });
                }
            }

            let isUnderLayer = props.is_under_layer
            let isMobile = props.is_mobile

            return {
                master,
                searchCondition,
                isUnderLayer,
                isMobile,
            }
        },
    })
</script>